import React from "react";
import { connect } from "react-redux";
import {
  setSelectedCabin,
  setAdultCount,
  // setSeniorCount,
  setChildCount,
  // setInfantInLapCount,
  // setInfantInSeatCount
} from "./actions";
import { getModalContentValidity } from "./selectors";
// import FlatButton from 'material-ui/FlatButton';
// import RaisedButton from 'material-ui/RaisedButton';
// import FilterIcon from 'material-ui/svg-icons/content/filter-list';
// import { TextField } from 'redux-form-material-ui'
// import { AutoComplete as MUIAutoComplete } from 'material-ui';
// import MUIAutoComplete from 'material-ui/AutoComplete'
// import { fetchOffers } from '../offers/offersActions';

// import SortIcon from 'material-ui/svg-icons/content/sort';
// import Popover from 'material-ui/Popover/Popover'
import MenuItem from "material-ui/MenuItem";
import { reduxForm, Field } from "redux-form";

// import Paper from 'material-ui/Paper'
// import Menu from 'material-ui/Menu'

// import currencies from '../generalcomponents/Currencies';
// import countries from '../generalcomponents/Countries';

// import styles from './styles.css';

// import {Menu, MenuItem} from 'material-ui/Menu';

// import { Toggle } from 'redux-form-material-ui';
// import { Field } from 'redux-form';
// import Toggle from 'material-ui/Toggle';

import {
  SelectField
  // TextField,
  // Toggle
} from "redux-form-material-ui";

// const SampleDropDownMenu = ({ handleMenuItemClick, dataSource }) => {

// };

// const ModalContent = () => {
class ModalContent extends React.Component {
  styles = {
    // inputStyles: {width: '30%', margin: '0 auto'}
    inputStyles: { maxWidth: "320px", margin: "0 auto" }
    // inputStyles: {width: '100%', margin: '0 auto'}
  };

  render() {
    // var { selectFieldName } = this.props;
    // console.log('dispatch in ModalContent', this.props.change)

    const { modalContentValidity } = this.props;

    var numbers = [
      <MenuItem key="zero" value={0} primaryText="0" />,
      <MenuItem key="one" value={1} primaryText="1" />,
      <MenuItem key="two" value={2} primaryText="2" />,
      <MenuItem key="three" value={3} primaryText="3" />,
      <MenuItem key="four" value={4} primaryText="4" />,
      <MenuItem key="five" value={5} primaryText="5" />,
      <MenuItem key="six" value={6} primaryText="6" />
    ];

    return (
      <div>
        <div>
          {/* <div class="col-xs-12 col-sm-12 col-md-6 col-md-offset-3"> */}
          <div style={this.styles.inputStyles}>
            <Field
              fullWidth
              component={SelectField}
              name={"passenger_cabin_select_field"}
              floatingLabelText="Cabin"
              // fullWidth={true}
              onChange={(obj, selectedCabin) => {
                // console.log('WHAT? cabinSelected', selectedCabin)
                this.props.dispatch(setSelectedCabin(selectedCabin));
              }}
              // defaultValue={'Emine'}
              // fullWidth={true}
              // labelStyle={this._styles.inputStyle}
            >
              {// economy,premium,business,first (PPN Enum Values)
              [
                <MenuItem
                  key="economy"
                  value="economy"
                  primaryText="Economy"
                />,
                <MenuItem
                  key="premium"
                  value="premium"
                  primaryText="Premium Economy"
                />,
                <MenuItem
                  key="business"
                  value="business"
                  primaryText="Business"
                />,
                <MenuItem key="first" value="first" primaryText="First" />
              ]}
            </Field>
          </div>

          <div style={this.styles.inputStyles}>
            <Field
              fullWidth
              component={SelectField}
              name={"adult_select"}
              // fullWidth={true}
              floatingLabelText="Adults (18+)"
              onChange={(obj, selectedCount) => {
                this.props.dispatch(setAdultCount(Number(selectedCount)));
              }}
            >
              {numbers}
            </Field>
          </div>

          <div style={this.styles.inputStyles}>
            <Field
              fullWidth
              component={SelectField}
              name={"child_select"}
              // fullWidth={true}
              floatingLabelText="Children (2 - 17)"
              onChange={(obj, selectedCount) => {
                this.props.dispatch(setChildCount(Number(selectedCount)));
              }}
            >
              {numbers}
            </Field>
          </div>

          {/* 
          
          <div style={this.styles.inputStyles}>
            <Field
              fullWidth
              component={SelectField}
              name={'senior_select'}
              // fullWidth={true}
              floatingLabelText='Seniors (65+)'
              onChange={(obj, selectedCount) => {
                this.props.dispatch(setSeniorCount(Number(selectedCount)))
              }}
              >

              { numbers }

            </Field>
          </div>
          
          <div style={this.styles.inputStyles}>
            <Field
              fullWidth
              component={SelectField}
              name={'infant_in_lap_select'}
              // fullWidth={true}
              floatingLabelText='Infants in lap (2)'
              onChange={(obj, selectedCount) => {
                this.props.dispatch(setInfantInLapCount(Number(selectedCount)))
              }}
              >

              { numbers }

            </Field>
          </div>

          <div style={this.styles.inputStyles}>
            <Field
              fullWidth
              component={SelectField}
              name={'infant_in_seat_select'}
              // fullWidth={true}
              floatingLabelText='Infants in seat (2)'
              onChange={(obj, selectedCount) => {
                this.props.dispatch(setInfantInSeatCount(Number(selectedCount)))
              }}
              >

              { numbers }

            </Field>
          </div> */}

          <div class="error-msg">
            {!modalContentValidity.isModalContentValid &&
              modalContentValidity.errorMessage}
          </div>
        </div>
      </div>
    );
  }
}

// Decorate with redux-form
ModalContent = reduxForm({
  form: "passengerCabinModalContent"
})(ModalContent);

function mapStateToProps(state) {
  const { preferredCabin, passengers } = state.landingPage;
  // const { adultCount, seniorCount, childCount, infantInLapCount, infantInSeatCount } = passengers
  const { adultCount, childCount } = passengers;

  return {
    // Initial values are needed because when modal is closed, old values are destroyed
    initialValues: {
      passenger_cabin_select_field: preferredCabin,
      adult_select: adultCount,
      // senior_select: seniorCount,
      child_select: childCount
      // infant_in_lap_select: infantInLapCount,
      // infant_in_seat_select: infantInSeatCount
    },
    modalContentValidity: getModalContentValidity(state)
    // adult_select: adultCount,
  };
}

export default connect(mapStateToProps)(ModalContent);

// ModalContent = reduxForm({
//   form: 'trapPage'
//   // validate
// })(ModalContent)

// function mapStateToProps(state) {
//   return {
//     initialValues: {'passenger-cabin-select': 'Economy'}
//   }
// }

// export default connect(mapStateToProps)(ModalContent);

// export default ModalContent;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/PassengerCabinField/ModalContent.js